$(function() {
  checkOpenModalDegustacaoPendente();
  checkOpenModalNovoEmissorMainoFlex();
  checkOpenModalBoasVindas();
});

const modalIniciarTeste = $('#modal-iniciar-teste');
const modalBoasVindas = $('#modal-boas-vindas');
const btnTestarDadosFicticios = $('#btn-testar-dados-ficticios');
if(modalIniciarTeste.length > 0){
  modalIniciarTeste.on('shown.bs.modal', function() {

    const btnIniciarTeste = modalIniciarTeste.find('.modal-footer button');

    if (btnIniciarTeste.length > 0) {
      btnIniciarTeste.on('click', function() {
        const acao = $(this).text().trim();
        const tipoDeDados = $(this).attr('id');
        enviaEventoPostHog("Fechou o modal de boas-vindas do Degustação", {
          trackAcao: acao,
          trackPopularBase: tipoDeDados == 'btn-testar-dados-ficticios' ? 'sim' : 'nao'
        });
      });
    }
  });
}

function checkOpenModalBoasVindas(){
  if(modalBoasVindas.length > 0){
    modalBoasVindas.modal({
      show: true,
      backdrop: "static",
      keyboard: false,
    });
  }
}

function fecharModalBoasVindas(){
  if (modalBoasVindas.length > 0) {
    modalBoasVindas.modal('hide');
  }
}

$('#btn-testar-meus-dados').on('click', function(ev) {
  ev.preventDefault();
  fecharModalBoasVindas();
});

function handleAjaxComplete(ev, data, attr) {
  if (data.status === 200) {
    fecharModalBoasVindas();
  } else {
    handleCancelAnimateButton();
    exibe_erro(data.responseJSON?.message || 'Erro ao criar dados de demonstração');
  }
};

function handleAnimateButton() {
  if (btnTestarDadosFicticios.length > 0) {
    btnTestarDadosFicticios.html('<div><div class="spinner-border text-maino-blsendEventCadastroFinalizadoue mr-2" role="status"></div> Criando dados...</div>');
    btnTestarDadosFicticios.prop('disabled', true);
  }
}

function handleCancelAnimateButton() {
  if (btnTestarDadosFicticios.length > 0) {
    btnTestarDadosFicticios.html('Teste com dados de demonstração');
    btnTestarDadosFicticios.prop('disabled', false);
  }
}

$('#btn-testar-dados-ficticios').on('click', function() {
  handleAnimateButton();
  if(modalIniciarTeste.length > 0){
    modalIniciarTeste.find('#tipo_de_dados').val('dados_ficticios');
    modalIniciarTeste.one('ajax:complete', handleAjaxComplete).submit();
  }
});

function checkOpenModalDegustacaoPendente(){
  const elModalDegustacaoPendente = $('#modal-degustacao-pendente');
  if(elModalDegustacaoPendente.length > 0){
    elModalDegustacaoPendente.modal({
      show: true,
    });

    elModalDegustacaoPendente.on('hidden.bs.modal', function() {
      $(this).off('hidden.bs.modal');
      handleModalDegustacaoPendenteTour();
    });
    handleModalPrimeiroAcesso(elModalDegustacaoPendente, "Fechou o modal de boas-vindas do Degustação");
  }
}

function enviaEventoRdStation(conversionIdentifier) {
  $.ajax({
    url: "/rd/registra_eventos",
    type: "POST",
    data: JSON.stringify({ conversion_identifier: conversionIdentifier }),
    contentType: "application/json",
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content")
    }
  });
}

$(document).on("click", "#usar-flex-sem-consultor", function (ev) {
  ev.preventDefault();
  enviaEventoRdStation("usar-flex-sem-consultor");
});

$(document).on("click", "#consultor-no-flex", function (ev) {
  ev.preventDefault();
  exibe_mensagem(t("interface.auto_cadastro.mensagem_falar_com_consultor"))
  enviaEventoRdStation("consultor-no-flex");
  $(ev.target.closest('.modal')).modal('hide');
});

$(document).on("click", "#tgg-no-perfil-fale-com-consultor", function (ev) {
  ev.preventDefault();
  exibe_mensagem(t("interface.auto_cadastro.mensagem_falar_com_consultor"))
  enviaEventoRdStation("tgg-no-perfil-fale-com-consultor");
  $(ev.target.closest('.modal')).modal('hide');
});

function checkOpenModalNovoEmissorMainoFlex(){
  const elModalNovoEmissorMainoFlex = $('#modal-novo-emissor-maino-flex');
  if(elModalNovoEmissorMainoFlex.length > 0){
    elModalNovoEmissorMainoFlex.modal({
      show: true,
    });
    handleModalPrimeiroAcesso(elModalNovoEmissorMainoFlex, "Modal de boas-vindas ao Mainô Flex");
  }
}

function handleModalDegustacaoPendenteTour(){
  const elModalDegustacaoPendenteTour = $('#modal-degustacao-pendente-tour');
  if(elModalDegustacaoPendenteTour.length > 0){
    elModalDegustacaoPendenteTour.modal({
      show: true,
    });
  }
  elModalDegustacaoPendenteTour.on('hidden.bs.modal', function() {
    enviaEventoPostHog("Fechou o modal com conheça o ERP");
  });
  elModalDegustacaoPendenteTour.on('shown.bs.modal', function() {
    handleYoutubePlayer();
  });
}

function enviaEventoPostHog(eventName, extraDetails = {}) {
  const detail = {
    posthogEvent: eventName,
    ...extraDetails
  };
  const event = new CustomEvent("posthog:capture", { detail });
  document.dispatchEvent(event);
}

function handleYoutubePlayer(){
  if (!window.YT) {
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);
  }
  window.onYouTubeIframeAPIReady = function() {
    new YT.Player('player-degustacao-pendente-tour', {
      videoId: 'ZNk8t8h_x4g',
      events: {
        onStateChange: function(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            enviaEventoPostHog("Deu play no video de degustação pendente tour");
          }
          if (event.data == YT.PlayerState.PAUSED) {
            enviaEventoPostHog("Deu pause no video de degustação pendente tour");
          }
          if (event.data == YT.PlayerState.ENDED) {
            enviaEventoPostHog("Finalizou o video de degustação pendente tour");
          }
        }
      }
    });
  };
}

function handleModalPrimeiroAcesso(elModal, eventName){
  const btnsFooter = elModal.find('.modal-footer button, .modal-footer a');

  if (btnsFooter.length > 0) {
    btnsFooter.on('click', function() {
      const acao = $(this).text().trim();
      enviaEventoPostHog(eventName, { trackAcao: acao });
    });
  }
}
